
import { Col } from 'element-ui'

export default {
  extends: Col,
}
